import { createContext } from 'react';

const leloContext = createContext();

export default leloContext;
